import {FACTIONS} from "../../../constants/factions";

export const DRAGONS_QUOTES = [{
  quote: 'Вы пашете землю. Мы пашем небо. Вы сеете зерно. Мы сеем огонь',
  author: 'Аврелий Золоточешуй, верховный дракон Небесных легионов',
  factionId: FACTIONS.DRAGONS
}, {
  quote: 'Ваши лучшие отряды — моя закуска перед настоящим обедом',
  author: 'Тиберий Твердокрыл, дракон-префект Башенных гнездовий',
  factionId: FACTIONS.DRAGONS
}, {
  quote: 'Полет — это свобода. Свобода выбрать, кого сжечь первым. И вторым. И третьим',
  author: 'Валерия Когнита, куратор драконьих ферм Сернебальта',
  factionId: FACTIONS.DRAGONS
}, {
  quote: 'Чешуя толще твоей стены. Огонь горячее твоей кузницы. А сам я быстрее твоей мысли',
  author: 'Юния Огнедышащая, старший дракон гнезд Выжженного клина',
  factionId: FACTIONS.DRAGONS
}, {
  quote: 'Эти ничтожества строят башни, чтобы быть ближе к небу. Мы спим на земле. Небо само к нам приходит',
  author: 'Лукреция Долголетняя, дракон-куратор родовых кладок Сернебальта',
  factionId: FACTIONS.DRAGONS
}, {
  quote: 'Огонь не знает пощады. Знаю только я. И я её не проявляю',
  author: 'Сульпиций Громоподобный, верховный дракон-герольд гнезд Стальных теней',
  factionId: FACTIONS.DRAGONS
}, {
  quote: 'Лишь однажды можно увидеть мой полёт',
  author: 'Постумий Огнекрыл, дракон-авгур скал Попутных ветров',
  factionId: FACTIONS.DRAGONS
}]